import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

export class Schedule extends TranslatableModel {

    static get translatableAttributes() {

        return ['name'];
    }

    static get conditions() {
        return [
            { value: 'before_in', name: 'BEFORE_CHECK_IN' },
            { value: 'after_in', name: 'AFTER_CHECK_IN', },
            { value: 'before_out', name: 'BEFORE_CHECK_OUT' },
            { value: 'after_out', name: 'AFTER_CHECK_OUT' },
            { value: 'after_booking', name: 'AFTER_BOOKING' }
        ];
    }

    get rangeTypes() {

        return [
            { value: 'booking', name: 'BOOKING_DATE_BETWEEN' },
            { value: 'arrival', name: 'ARRIVAL_DATE_BETWEEN' },
            { value: 'departure', name: 'DEPARTURE_DATE_BETWEEN' },
        ];
    }

    get reservationStatuses() {
        return [

            { value: 'cancelled', name: 'CANCELLED' },
            { value: 'confirmed', name: 'CONFIRMED' },
            { value: 'pending', name: 'PENDING_CONFIRMATION' },
            { value: 'checked_in', name: 'CHECKED_IN' },
            { value: 'checked_out', name: 'CHECKED_OUT' },
            { value: 'no_show', name: 'NO_SHOW' },
        ];
    }

    setStatus(value) {

        const statuses = {

            true: '1',
            false: '0'
        }

        if (typeof value === "boolean") {

            return statuses[value];
        }

        return value;
    }

}
AccessorsMutatorsDecorator('id', ...Schedule.translatableAttributesWithLanguageAliases, 'status', 'template', 'template_type', 'template_id',
    'type', 'days', 'condition', 'time', 'reservation_status', 'only_for_selected', 'range_type', 'start_date', 'end_date', 'only_for_specified',
    'sources', 'property', 'property_id', 'template_name', 'template_name_ar')(Schedule);


// WEBPACK FOOTER //
// ./src/pms-api/models/schedule.model.js